<template>
  <qc-container title="物流公司管理">
    <page-request ref="table" url="/api/mgr/sys/express/list" :table-header="tableHeader" :expend="expend" :op-width="200">
      <t-button @click="doEdit()">添加</t-button>
      <t-button @click="batchImport">批量导入</t-button>
      <import-excel ref="importExcel" title="批量导入"
                    :action="baseURL+'/api/mgr/sys/express/importList'"
                    :download-url="baseURL+'/api/mgr/sys/express/downTemplate'"
                    :error-url="baseURL+'/api/mgr/sys/express/downloadErrorImportList'"
                    @on-success="pageReloadData"></import-excel>
      <export-excel @action="addExportTask" ref="exportExcel" task-name="导出物流公司" task-key="expressCode" file-name="物流公司.xlsx" title="批量导出" button-name="批量导出" ></export-excel>
      <template #op="scope">
        <b-button @click="doEdit(scope.row)">编辑</b-button>
        <b-button @click="doDel(scope.row)">删除</b-button>
      </template>
    </page-request>
    <express-add ref="add" @load="pageReloadData"></express-add>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import ExpressAdd from "@view/order/op/express-add.vue";
import PageRequest from "@/components/base/page-request.vue";
import TButton from "@/components/el/t-button.vue";
import BButton from "@/components/el/b-button.vue";
import ImportExcel from "@/components/base/importExcel.vue";
import ExportExcel from "@/components/base/ExportExcel.vue";

export default {
  name: "logistics",
  components: {ExportExcel, ImportExcel, BButton, TButton, PageRequest, ExpressAdd, QcContainer},
  data() {
    return {
      tableHeader:[
        {prop: "itemDesc", label: "物流名称"},
        {prop: "itemCode", label: "物流代码",width:150},
        {prop: "sort", label: "排序",width:150}
      ],
      expend:[
        {prop: "itemDesc", label: "物流名称"},
        {prop: "itemCode", label: "物流代码"},
      ]
    }
  },
  mixins: [tableBase],
  methods: {
    batchImport(){
      this.$refs.importExcel.open();
    },
    doEdit(row){
      this.$refs.add.open(row);
    },
    doDel(row){
      this.msgConfirm("/api/mgr/sys/express/delete",{id:row.id},()=>{
        this.pageReloadData();
      })
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
